import React, { useState } from 'react';
import { initializeApp } from 'firebase/app';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../../firebase';
import { useDispatch } from 'react-redux';
import { showErrorSnackbar, showSuccessSnackbar } from '../../shared/snackbar/snackbar-slice';

// Initialize Firebase app with your configuration
// const firebaseConfig = {
//   // Your Firebase configuration object
// };

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      await signInWithEmailAndPassword(auth, email, password);
      dispatch(showSuccessSnackbar('Login successful!'));
      // Redirect to the desired page upon successful login
    } catch (error) {
      dispatch(showErrorSnackbar('Login failed!'));
      console.log('Login error:', error.message);
    }
  };

  return (
    <div>
      <h1>Login Page</h1>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default LoginPage;
